// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLogoPage-Link_cls1__+-mCc","cls2":"VeloLogoPage-Link_cls2__jMuVz VeloLogoPage-Link_cls1__+-mCc"};